import { useState } from "react";
import { useLayerList } from "../../hooks";
import { LAYER_STATES } from "../../redux/reducers/mapViewReducer";
import { LayerListIcon } from "../Icons";
import LayerItem from "./LayerItem";
import {
  LayerListContainer,
  StyledLayerList,
  StyledMenu,
} from "./LayerList-styled";

const LAYER_LIST_STATES = Object.freeze({
  ...LAYER_STATES,
  PARTIALLY_LOADED: "partiallyLoaded",
});

const LayerListWidget = ({ view, t, config, isWidget, isSidebar }) => {
  const [showLayerList, setShowLayerList] = useState(false);
  const [layers, setLayers] = useLayerList();

  if (!view) return;

  return (
    <>
      {layers.map((item) => (
        <LayerItem
          key={item.title}
          view={view}
          config={config}
          title={item.title}
          groupedLayers={item.groupedLayers}
          information={item.information}
          getLayerTitle={item.getLayerTitle}
          getLayerInformation={item.getLayerInformation}
          t={t}
          layerListVisible={showLayerList}
          isSidebar={isSidebar}
        />
      ))}
    </>
  );

  if (!isWidget) {
    return (
      <StyledLayerList>
        {layers.map((item) => (
          <LayerItem
            key={item.title}
            view={view}
            config={config}
            title={item.title}
            groupedLayers={item.groupedLayers}
            information={item.information}
            t={t}
            layerListVisible={showLayerList}
          />
        ))}
      </StyledLayerList>
    );
  } else {
    return (
      <LayerListContainer show={showLayerList}>
        <div
          onClick={() => {
            setShowLayerList(!showLayerList);
          }}
          className="esri-widget--button gtag"
          data-tag-name="LayerList"
        >
          <LayerListIcon width="16" height="16" />
        </div>
        <StyledMenu show={showLayerList}>
          {layers.map((item) => (
            <LayerItem
              key={item.title}
              view={view}
              config={config}
              title={item.title}
              groupedLayers={item.groupedLayers}
              information={item.information}
              t={t}
              layerListVisible={showLayerList}
            />
          ))}
        </StyledMenu>
      </LayerListContainer>
    );
  }
};

export default LayerListWidget;
